import {
  ErrorBoundaryLayout,
  ErrorPage,
  RouterErrorPage,
} from '@wellesley/error-kit'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { useAppsRoutes } from './useAppsRoutes'
import { HostRouteObserver } from '@wellesley/host-remote'
import { Layout } from '../Layout'
import { MemoizedRemoteApp } from '../../features/remote-app/RemoteApp'

const errorRoute = { path: '*', element: <ErrorPage error={404} /> }
const devAppRoute = [
  {
    path: '/g/:groupname/*',
    element: (
      <MemoizedRemoteApp key="dev" src="http://localhost:3001" name="Dev App" />
    ),
  },
  {
    path: '*',
    element: (
      <MemoizedRemoteApp key="dev" src="http://localhost:3001" name="Dev App" />
    ),
  },
]

export const Router = () => {
  const routes = useAppsRoutes()

  const children =
    process.env.DOMAIN_ENV === 'dev' ? devAppRoute : [...routes, errorRoute]

  const router = createBrowserRouter([
    {
      element: (
        <>
          <HostRouteObserver />
          <Layout>
            <ErrorBoundaryLayout />
          </Layout>
        </>
      ),
      errorElement: <RouterErrorPage />,
      children,
    },
  ])

  return <RouterProvider router={router} />
}
